import React from 'react';
import PropTypes from 'prop-types';
import withRouter from 'HOCs/withRouter';
import hoistNonReactStatics from 'hoist-non-react-statics';

const withCustomRouter = WrappedComponent => {
    const WithCustomRouter = ({ router, ...props }) => {
        const { goBack, push, replace } = router;
        const customRouter = { goBack, push, replace };

        return (
            <WrappedComponent
                { ...props }
                customRouter={ customRouter }
            />
        );
    };

    WithCustomRouter.propTypes = {
        router: PropTypes.object.isRequired
    };
    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithCustomRouter.displayName = `withCustomRouter(${wrappedComponentName})`;

    const connectedComponent = withRouter(WithCustomRouter);

    return hoistNonReactStatics(connectedComponent, WrappedComponent, { fetchData: true });
};

export default withCustomRouter;
